export const HUNT_PACKAGE_MAX = 25;
export const HUNT_MAX = 25;
export const API_KEYS_MAX_KEYS = 20;
